import React, { Component, Fragment } from 'react'
import { Layout } from 'antd/lib/index'
import { Breadcrumb, Button, Card, Icon, message, Popconfirm, Row, Select } from "antd";
import SubsidiariesApi from '../../api/Subsidiaries'

import style from './style.css'
import { strVal } from '../../modules/Utils'
import { withRouter } from 'react-router-dom'
import CustomTable from '../../elements/Table/CustomTable'
import Status from "../../elements/Status";

const { Content } = Layout

const NewSubsidiariesButton = withRouter(({ history }) => {
  return (
    <Button
      type={'primary'}
      size={'small'}
      icon={'plus'}
      onClick={() => {
        history.replace('new')
      }}>
      New
    </Button>
  )
})

class Subsidiaries extends Component {
  api = new SubsidiariesApi()
  state = {
    list: [],
    data: [],
    fetching: false,
  }

  componentDidMount () {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({ fetching: true })
      let list = await this.api.list()
      this.setState({ data: list, list, fetching: false })
    } catch (err) {
      message.error(err.errorMessage)
      this.setState({ fetching: false })
    }
  }

  columns = [
    {
      Header: 'Code',
      accessor: 'code',
      width: 80,
    },
    {
      Header: 'Full Name',
      accessor: 'fn',
      width: 400,
      Cell: ({ value, original }) => (
        <a onClick={() => (window.location = `#/corporates/subsidiaries/${original._key}`)}>{value}</a>
      ),
    },
    {
      Header: 'BaseURL',
      accessor: 'baseURL',
    },
    {
      Header: 'Currency',
      accessor: 'reportingCurrency',
      hideable:true,
      hideDefault: true,
    },
    {
      Header: 'Tax No',
      accessor: 'taxRegistration',
      hideable:true,
      hideDefault: false,
    },
    {
      Header: 'Invoice Prefix',
      accessor: 'invoice_prefix',
      hideable:true,
      hideDefault: false,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ value, original }) => strVal(original, 'email.label'),
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: ({ value, original }) => strVal(original, 'phone.label'),
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 150,
      Cell: ({ value }) => value && <Status value={value} tooltip={false} />,
      filterMethod: (filter, row) => {
        const activeArray = ['Active']
        const nonActiveArray = ['Inactive', 'Terminated']

        if (filter.value === 'all') {
          return true
        }
        return filter.value === true
          ? activeArray.includes(row[filter.id])
          : nonActiveArray.includes(row[filter.id])
      },
      Filter: ({ onChange, filter }) => (
        <Select
          onChange={value => onChange(value)}
          style={{ width: '100%' }}
          defaultValue="active"
          value={filter ? filter.value : 'all'}>
          <Select.Option value="all">All</Select.Option>
          <Select.Option value={true}>Active</Select.Option>
          <Select.Option value={false}>None Active</Select.Option>
        </Select>
      ),
    },
   /* {
      Header: 'Operation',
      accessor: 'operation',
      width: 100,
      Cell: ({ value, original }) => (
        <Fragment>
          <Popconfirm title="Sure to remove?" onConfirm={() => this.remove(original)}>
            <a>
              <Icon
                style={{
                  paddingTop: '10px',
                  marginRight: '5px',
                  color: '#08c',
                }}
                type="delete"
              />
              Remove
            </a>
          </Popconfirm>
        </Fragment>
      ),
    },*/
  ]

  render () {
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="#/corporates">Corporates</Breadcrumb.Item>
              <Breadcrumb.Item>Tenants List</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>Tenants</h2>
            <p className={style.paragraph}>List of all Tenants in system. You can filter or create a new tenant.</p>
          </Row>
        </Card>
        <Card className={style.contentCard} title={'Tenant list'}>
          <CustomTable
            isFilterable={true}
            CreateButton={() => <NewSubsidiariesButton/>}
            fetch={this.fetch}
            fetching={this.state.fetching}
            columns={this.columns}
            data={this.state.list}
          />
        </Card>
      </Content>
    )
  }
}

Subsidiaries.propTypes = {}
Subsidiaries.defaultProps = {}

export default Subsidiaries
